// Service-worker routing helpers (pure, unit-tested).
//
// `/api/files/*` serves raw uploaded binaries (PDFs, mail files, video) straight
// off the object store. These are served NetworkOnly (transparent passthrough)
// rather than through any caching strategy:
//   * PDFs render in an <iframe> via the browser's built-in viewer, which needs
//     real Range-request responses. When a caching strategy caught the iframe
//     `navigate` load it substituted the app-shell "/" document fallback (a
//     DENY-framed page) → "Refused to display … X-Frame-Options: deny" and the
//     PDF downloaded instead of rendering (root-caused 2026-07-09).
//   * Routing binary downloads through the JSON-API NetworkFirst cache is wrong
//     regardless (can't cache 206 Partial Content; bloats the cache).
// A true SW bypass isn't possible because defaultCache ends in a catch-all
// NetworkFirst, so sw.ts registers an explicit NetworkOnly route (matched via
// this predicate) ahead of everything else. Two things sw.ts layers on top that
// this predicate does NOT cover: it excludes `image` requests (they keep their
// cache) and excludes these paths from the "/" offline fallback (Serwist
// force-attaches that fallback to every strategy, NetworkOnly included).
export function shouldBypassServiceWorker(pathname: string): boolean {
  return pathname.startsWith("/api/files/");
}

// Runtime cache the service worker keeps app-shell navigations in (NetworkFirst; the copy
// is only used when the network fails). Shared with the page so the chunk-load recovery
// can drop a stale copy of the current URL before it reloads (lib/chunkRecovery.ts).
export const FLOW_PAGES_CACHE = "flow-pages";
